import { Component, Input, Type } from '@angular/core';
import { SharedService } from '../../_services/shared.service';
import { TranslateModule } from '@ngx-translate/core';
import { LinkOpenerService } from '../../_services/link-opener.service';

@Component({
  selector: 'app-card',
  imports: [TranslateModule],
  templateUrl: './card.component.html',
  standalone: true,
  styleUrl: './card.component.css',
})
export class CardComponent {
  @Input() title!: string;
  @Input() description!: string;
  // Optional: without it the card has no "More Information" footer
  @Input() moreInformation?: string;
  @Input() image!: string;
  @Input() formRef!: Type<any>;
  @Input() label!: string;
  @Input() isTeam?: boolean;
  // Optional: an information card opens this link in a new tab instead of a form
  @Input() link?: string;

  constructor(
    private sharedService: SharedService,
    private linkOpenerService: LinkOpenerService,
  ) {}

  onCardClick() {
    if (this.link) {
      this.linkOpenerService.openMyBFHLink(this.link);
      return;
    }

    this.toggleModal();
  }

  toggleModal() {
    const formData = {
      formRef: this.formRef,
      isTeam: this.isTeam,
    };
    this.sharedService.toggleModal(this.label, formData);
  }

  openUrlLocalized(event: Event) {
    event.preventDefault();
    if (this.moreInformation)
      this.linkOpenerService.openMyBFHLink(this.moreInformation);
  }
}
